import { useQuery } from "@tanstack/react-query";
import type { Opportunity } from "@/hooks/api/use-account-opportunities";
import { api, generateQueryKey } from "@/lib/api";

/**
 * Hook to fetch opportunities aggregated across all accounts associated with a person
 * @param personId - The person ID to fetch opportunities for
 * @returns Aggregated opportunities, loading state, and error
 */
export function usePersonOpportunities(personId?: string) {
  return useQuery<Opportunity[]>({
    queryKey: generateQueryKey(
      `datahub/persons/${encodeURIComponent(personId || "")}/opportunities/`,
    ),
    queryFn: () =>
      api.get<Opportunity[]>(
        `datahub/persons/${encodeURIComponent(personId || "")}/opportunities/`,
      ),
    enabled: !!personId,
  });
}
